import React from 'react'
import Link from 'gatsby-link'
import styled from 'react-emotion'
import { css } from 'emotion'
import _ from 'lodash'

import Logo from './header/logo'
import Navigation from './header/Navigation'
import MobileNav from './header/MobileNav'

const HeaderClass = css`
  height: 5rem;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	box-shadow: 0 1px 4px rgba(53, 57, 71, .3);
	background-color: #fff;
	display: flex;
  padding: 0 2rem;
  z-index: 100;

  @media (min-width: 776px) {
		padding: 0 3.1rem;
	}
  
`
const LogoContainer = styled.div`
	flex: 1;
	display: flex;
	align-items: center;
`
const LogoWrapper= styled.div`
	width: 6rem;
	padding: 1rem 0;
  display: inline-block;
  position: relative;
  z-index: 100;
`

// @media (min-width: 1025px) {
// 	width: 13rem;
// 	padding: 1rem 2.5rem;
// }

const NavigationWrapper = styled.nav`
	display: none;
	@media (min-width: 1025px) {
		display: flex;
	}
`

const MobileNavWrapper = styled.div`
  display: flex;
  align-items: center;

	@media (min-width: 1025px) {
		display: none;
	}
`

const Text = styled.h3`
	font-weight: 200;
	margin-bottom: 0;
	margin-left: 1rem;
	font-style: italic;
	margin-top: 1rem;
	@media (min-width: 800px) {
		margin-top: 0;
	}
	@media (min-width: 1200px) {
		margin-top: 1rem;
	}
`

const buildLinks = (data) => {
	const links =  [
		{
			label: 'Get Started',
			links: [
				{ to: '/schedule', label: 'Schedule a Demo' },
				{ to: 'https://app.trywhistle.com/register?source=whistle-marketing', label: 'Try it Free', external: true }
			]
		
		},
		{ label: 'Integrations & Partners',
			links: [
				{ to: '/cloudbeds', label: 'Cloudbeds' }
			]
		},
		{ to: '/#how-it-works', label: 'How It Works' },
		{ to: '/#features', label: 'Features' },
		
		{
			label: 'Hotels & Customers',
			links: [
				{ to: '/testimonials', label: 'Testimonials' },
				{ to: '/hilton', label: 'Hilton' },
				{ to: '/ihg', label: 'IHG' },
				{ to: '/choice', label: 'Choice' },
				{ to: '/independent', label: 'Independent' },
			]
		},
		{
			label: 'Company',
			links: [
				{ to: '/about', label: 'About Us' },
				{ to: '/press', label: 'Press' },
				{ to: '/blog', label: 'Blog' },
			]
		},
		{
			label: 'Login',
			external: true,
			button: true,
			to: 'https://app.trywhistle.com/login'
		}
	]
	console.log("DATA", data)
	data.edges.map(d => {
		const { label, title } = _.get(d, ['node', 'frontmatter']) || {}
		const partner = {
			to: `/${title}`,
			label,
		}
		links[1].links.push(partner)
	}) 
	return links
}

const Header = (props) => {
	const links = buildLinks(props)

	return (
		<header className={HeaderClass}>
			<LogoContainer>
        <LogoWrapper>
          <Link to={'/'}>
            <Logo />
          </Link>
				</LogoWrapper>
				<Text>"At your service."</Text>
			</LogoContainer>
			<NavigationWrapper>
				<Navigation links={links} />
      </NavigationWrapper>
      <MobileNavWrapper>
        <MobileNav links={links} />
      </MobileNavWrapper>
		</header>
	)
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js